class AppUrl {
  // static BaseURL = `http://127.0.0.1:8000/api`;
  static BaseURL = `https://elearning.shofoll.com/api`;
  static frontURL = `https://elearning.shofoll.com/`;

  static HomeTopTitle = this.BaseURL + `/hometitle`;
  static HomeChart = this.BaseURL + `/allchartdata`;
  static HomeClientReview = this.BaseURL + `/allclientreview`;
  static HomeCourse = this.BaseURL + `/allfourcourse`;
  static AllCourse = this.BaseURL + `/allcourse`;
  static CourseDetails = this.BaseURL + `/coursedetails/`;
  static AllInformation = this.BaseURL + `/allinformation`;
  static AllInformation = this.BaseURL + `/allinformation`;
  static HomeProjects = this.BaseURL + `/allthreeproject`;
  static AllProjects = this.BaseURL + `/allproject`;
  static ProjectDetails = this.BaseURL + `/projectDetails/`;
  static HomeVideo = this.BaseURL + `/videodata`;
  static HomeTotalData = this.BaseURL + `/hometotaldata`;
  static ContactForm = this.BaseURL + `/contactsend`;
  static AllService = this.BaseURL + `/allservice`;
  static HomeTech = this.BaseURL + `/hometech`;
  static HomeAbout = this.BaseURL + `/homeabout`;
  static allAbout = this.BaseURL + `/allabout`;
}
export default AppUrl;
